import { render, staticRenderFns } from "./EquipmentList.vue?vue&type=template&id=1959b882"
import script from "./EquipmentList.vue?vue&type=script&lang=js"
export * from "./EquipmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports